export default __webpack_public_path__ + "static/media/macView.9ffd0c0d.png";